import { forwardRef } from "react"
import { Button as AButton } from "antd"
import { ModalContext, ModalContextProvider } from "../../../contexts"
import PropTypes from "prop-types"

ModalButtonComponent.propTypes = {
  button: PropTypes.elementType,
  modalProps: PropTypes.object,
  modal: PropTypes.elementType,
  title: PropTypes.string,
  item: PropTypes.any,
  onCustomClick: PropTypes.func
}

function ModalButtonComponent({
  button: Button = AButton,
  modalProps,
  modal,
  title,
  item,
  onCustomClick = null,
  ...props
}, ref) {
  return (
    <ModalContextProvider
      ref={ref}
      modal={modal}
      modalProps={modalProps}>
      <ModalContext.Consumer>
        {({ openModal }) =>
          <Button
            onClick={() => {
              openModal(item)
              onCustomClick && onCustomClick()
            }}
            {...props}>
            {title}
          </Button>
        }
      </ModalContext.Consumer>
    </ModalContextProvider>
  )
}

export const ModalButton = forwardRef(ModalButtonComponent)
